import { StepModel } from '@uag/welcome-shared/src/api/models';

const isCompleted = (p?: string) => (p ?? '').toLowerCase() === 'completed';

export function getVisibleSteps(steps: StepModel[]): StepModel[] {
    if (!steps.length) {
        return [];
    }

    const signIdx = steps.findIndex((s) => s.type === 'SignContract');
    if (signIdx === -1) {
        return steps;
    }

    const signStep = steps[signIdx];
    if (isCompleted(signStep.progress)) {
        return steps;
    }

    return steps.slice(0, signIdx + 1);
}
